import { useState, useEffect, useRef } from 'react';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
const FacetedSearchHybridItem = loadable(() => import('@Components/Shared/FacetedSearch/FacetedSearchHybridItem'));
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';


const FacetedSearchHybridField = (props) => {

    const [editLock, setEditLock] = useState(false);
    const [editValue, setEditValue] = useState('');
    const [options, setOptions] = useState(props.Options);
    const [anyChecked, setAnyChecked] = useState(props.Options.filter(c => c.Checked).length > 0);
    const routes = useRecoilValue(atoms.routes);

    useEffect(() => { setOptions(props.Options); setAnyChecked(props.Options.filter(c => c.Checked).length > 0) }, [props.Options]);

    const handleEditClick = (value) => {
        //save in this case else open the text input
        if (editLock && value) {
            options.filter(c => c.Value == editValue)[0].Name = value;
            setOptions(options);
            setEditLock(!editLock);
            setEditValue('');

            sandhillsRequest({
                url: routes.UpdateCustomWatchlistName,
                method: 'post',
                data: {
                    "watchlistID": editValue,
                    "name": value
                }
            }).then((result) => {
                window.location.href = window.location.href
            });
        }
        else {
            setEditLock(!editLock);
            setEditValue(options.filter(c => c.Name == value)[0].Value);
            setOptions(options);
        }
    }
    const removeWatchlist = (value, e) => {
        e.preventDefault();
        sandhillsRequest({
            url: routes.DeleteCustomWatchlist,
            method: 'post',
            data: {
                "watchlistID": value
            }
        }).then((result) => {
            if (result) {
                if (window.location.href.includes(value)) {
                    window.location.href = window.location.href.replace('&WLID=' + value, '');
                } else {
                    window.location.href = window.location.href
                }
                setOptions(options.filter(c => c.Value != value));
            }
        });
    }

    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substr(0, maxLength);
    };
    const handleCheckboxChange = (checkbox) => {
        if (!anyChecked && checkbox.currentTarget.checked) {
            setAnyChecked(true);
            options.filter(c => c.Value == checkbox.currentTarget.id)[0].Checked = true;
            options.filter(c => c.Value != checkbox.currentTarget.id).forEach(x => x.Checked = false);
            setOptions(options);
        } else {
            options.filter(c => c.Value == checkbox.currentTarget.id)[0].Checked = false;
            setAnyChecked(false);
        }
        if (options.some(x => x.Value == checkbox.currentTarget.id)) {
            let search = [];
            search.push({
                fieldName: 'WLID',
                value: checkbox.currentTarget.checked ? checkbox.currentTarget.id : ''
            });
            props.RunSearch(search);
        }
    }

    return (
        <>
            {
                options.map((item, index) =>
                    <div key={item.Name} className={'faceted-option-checkbox-container ' + (item.AdditionalClassName ? item.AdditionalClassName : item.MustBeSelectedIndividually ? 'individual-option' : '')} >
                        <label htmlFor={item.Value} style={{ paddingLeft: item.Indent * 10 + 'px', fontWeight: item.IsGroup ? 'bold' : 'normal' }}>
                            <input type='checkbox' disabled={anyChecked && !item.Checked || editLock} id={item.Value} name={item.FieldName} value={item.Value} onChange={(e) => { handleCheckboxChange(e) }} checked={item.Checked} />
                            <FacetedSearchHybridItem {...item} disabled={anyChecked && !item.Checked || editLock && item.Value != editValue} truncateText={truncateText} handleEdit={handleEditClick} removeWatchlist={removeWatchlist} />
                        </label>
                    </div>
                )}
        </>
    );
};

export default FacetedSearchHybridField;